import React from "react";
import { LastCalledItem } from "@dqm/react-last-called-component";

interface Props {
  items: LastCalledItem[];
}

export const LastCalled: React.FC<Props> = ({ items }) => {
  const isVisible = !!items.length;

  const containerClasses = ["dqm-tcui-last-called-container"];

  if (!isVisible) {
    containerClasses.push("dqm-tcui-last-called-container--hidden");
  }

  return (
    <div className={containerClasses.join(" ")}>
      <div className="dqm-tcui-last-called__heading">Nyt palvelemme</div>
      {items.map((item, i) => (
        <div
          key={`dqm-tcui-lc-item-${i}`}
          className="dqm-tcui-last-called__item"
        >
          <span>{item.title}</span>
        </div>
      ))}
    </div>
  );
};
